import * as React from 'react';
import {
  Body,
  FeedbackModal,
  InputLabel,
  Subtitle,
  Title
} from './Feedback.style';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import SubjectDropdown from './SubjectDropdown/SubjectDropdownContainer';
import { TabButton } from 'components/style/Buttons.style';
import { TextArea } from 'components/style/Inputs.style';

/**
 * Side Menu List of Links
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {StatelessComponent} Stateless functional React component.
 */
export const MenuListComponent = (
  { toggleModal, feedbackOpen, setBody, sendEmail, fullName, email },
  { t }
) => (
  <FeedbackModal isOpen={feedbackOpen} toggle={toggleModal}>
    <Title className="border-0" toggle={toggleModal}>
      {t("How're we doing?")}
    </Title>
    <Body>
      <Subtitle>
        {t(
          'The Novus Dashboard is in beta, and we would love to get your feedback on how we’re doing. Looks, functionality, ease of use, whatever! Anything goes.'
        )}
      </Subtitle>
      <Row>
        <Col sm="9">
          <Form>
            <FormGroup>
              <InputLabel for="feedback-full-name">{t('Name')}</InputLabel>
              <Title>{fullName}</Title>
            </FormGroup>
            <FormGroup>
              <InputLabel for="feedback-email">{t('Email')}</InputLabel>
              <Title>{email}</Title>
            </FormGroup>
            <FormGroup>
              <InputLabel for="feedback-topic">{t('Topic')}</InputLabel>
              <Row>
                <Col>
                  <SubjectDropdown />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <InputLabel for="feedback-body">{t('Feedback')}</InputLabel>
              <TextArea
                rows={5}
                id="feedback-body"
                placeholder={t('Feedback...')}
                onChange={(input) => setBody(input.target.value)}
              />
            </FormGroup>
            <TabButton onClick={() => sendEmail()}>{t('Submit')}</TabButton>
          </Form>
        </Col>
      </Row>
    </Body>
  </FeedbackModal>
);

MenuListComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default MenuListComponent;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/FeedbackComponent.js